import {Injectable} from '@angular/core';
import {AuthService} from '../../shared/services/auth.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ListadoActivacionesService {
    constructor(private http: HttpClient, private auth: AuthService) {
    }

    getHeaders() {
        const token = 'Bearer ' + this.auth.getToken();

        return new HttpHeaders({
            Authorization: token,
            'Content-Type': 'application/json'
        });
    }

    getUsers() {
        return this.http.get(environment.amenaEndpoint + 'users', {headers: this.getHeaders()});
    }

    listOrders() {
        return this.http.get(environment.amenaEndpoint + 'order/list', {headers: this.getHeaders()});
    }

    filterOrders(body: any) {
        return this.http.post(environment.amenaEndpoint + 'order/list/filter', body, {headers: this.getHeaders()});
    }

    filterAlerts(body: any) {
        return this.http.get(environment.amenaEndpoint + 'order/list/alerts' + body, {headers: this.getHeaders()});
    }

    getStateCoverage(order_id) {
        return this.http.get(environment.amenaEndpoint + 'order/' + order_id + '/broadband-status', {headers: this.getHeaders()});
    }

    updateAnnotation(order_id, annotations) {
        const url = environment.amenaEndpoint + 'order/' + order_id + '/annotation';
        const body = {annotation: annotations};

        return this.http.patch(url, body, {headers: this.getHeaders()});
    }
}
